// core styles are required for all packages
import "@mantine/core/styles.css";
import { StrictMode } from "react";
import { createTheme, MantineProvider } from "@mantine/core";
import "./App.css";
import { ROUTES } from "./routes/Routes";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "@mantine/core/styles.css";
import "react-awesome-button/dist/styles.css";

const theme = createTheme({
  defaultRadius: "sm",
  fontFamily: "Grandstander",
  primaryColor: "blue",
  breakpoints: {
    sm: "45em",
  },
});

const router = createBrowserRouter([...ROUTES]);
function App() {
  return (
    <StrictMode>
      <MantineProvider theme={theme}>
        <RouterProvider router={router} />
      </MantineProvider>
    </StrictMode>
  );
}

export default App;
